<div
    class="scroll-wrapper"
    cdk-scrollable>
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>
